import { atom, useAtom } from 'jotai';
import { RESULT_DISPLAY } from '@/configs/storageKeys';
import {
  RESULT_DISPLAY_TYPE,
  type ResultDisplayType,
} from '@/constants/resultDisplay';

const displayTypeAtom = atom<ResultDisplayType>(RESULT_DISPLAY_TYPE.LIST);

export function useAnimalDisplayType() {
  const [resultDisplay, setResultDisplay] = useAtom(displayTypeAtom);
  const changeResultDisplay = (display: ResultDisplayType) => {
    setResultDisplay(display);
    sessionStorage.setItem(RESULT_DISPLAY, display);
  };

  return {
    resultDisplay,
    setResultDisplay: changeResultDisplay,
  };
}
